module.exports = " <div id=app _v-6f58f7a2=\"\"> <div class=sidebar _v-6f58f7a2=\"\"> <card _v-6f58f7a2=\"\"></card> <list _v-6f58f7a2=\"\"></list> </div> <div class=main _v-6f58f7a2=\"\"> <message _v-6f58f7a2=\"\"></message> <text _v-6f58f7a2=\"\"></text> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-6f58f7a2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
 ** module id = 327
 ** module chunks = 0
 **/